import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {AnchorLinks, AnchorLink, Accordion, AccordionItem, InlineNotification, InlineCode, Feedback} from 'components';
function _createMdxContent(props) {
  const _components = {
    a: "a",
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Pool"
    }), "\n", _jsxs(Accordion, {
      children: [_jsxs(AccordionItem, {
        title: "Which coins can I mine on Braiins Pool?",
        children: [_jsxs(_components.p, {
          children: ["Currently you can mine ", _jsx(_components.strong, {
            children: "Bitcoin"
          }), " on Braiins Pool. At this time we don’t plan to support other alt-coins such as Ethereum (ETH), Monero (XMR), Litecoin (LTC), Dogecoin (DOGE) or others."]
        }), _jsxs(_components.p, {
          children: ["We believe that ", _jsx(_components.strong, {
            children: "Bitcoin is the future"
          }), " and we want to help build that future."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Ready to go?"
          }), " Set up a account on ", _jsx(_components.a, {
            href: "https://pool.braiins.com/signup/",
            children: "Braiins Pool"
          }), " and configure your miners according to our guides."]
        })]
      }), _jsxs(AccordionItem, {
        title: "What is a Share in proof of work?",
        children: [_jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Share"
          }), " is a unit which mining pools use for calculating the work done by a miner."]
        }), _jsx(_components.p, {
          children: "When a mining device is connected to the pool, it receives a computational task to be solved - computing hash values with certain properties (the outputs must be lower than the limit derived from difficulty)."
        }), _jsx(_components.p, {
          children: "Hashes satisfying the requirements are sent back to the pool and are used as a proof of the miner’s work. The quantity of miner’s work is registered in units called shares. If a hash (proof of work) with difficulty (d) is submitted by a miner then (d) shares are counted by the pool."
        }), _jsx(_components.p, {
          children: "To put it as simple as it could be:"
        }), _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "1 share = 1 proof of work on difficulty 1"
          }), "\n", _jsx(_components.li, {
            children: "5 shares = 1 proof of work on difficulty 5 (or 5 proofs of work on difficulty 1)"
          }), "\n", _jsx(_components.li, {
            children: "100 shares = 10 proofs of work on difficulty 10 (or .. you can see the pattern)"
          }), "\n"]
        }), _jsxs(_components.p, {
          children: ["The value that determines whether a hash results in a block find is ", _jsx(_components.em, {
            children: "network difficulty"
          }), ", but at the pool level there’s ", _jsx(_components.em, {
            children: "share difficulty"
          }), ", which is how difficult it is for a miner to submit a valid share to the pool."]
        }), _jsx(_components.p, {
          children: "So in the same way that there can be variance in finding blocks, there can be variance in finding shares because both processes are just inputting random numbers and looking for low enough outputs."
        }), _jsxs(_components.p, {
          children: ["The difference is only that the output needs to be much lower to find a block than it does to find a share (i.e. the ", _jsx(_components.em, {
            children: "network difficulty"
          }), " is significantly greater than the ", _jsx(_components.em, {
            children: "share difficulty"
          }), ".)"]
        }), _jsxs(_components.p, {
          children: ["We have also created a ", _jsx(_components.a, {
            href: "https://braiins.com/blog/bitcoin-mining-pools-luck-shares-estimated-hashrate",
            children: "detailed article"
          }), " on this topic that explains all the basics in a broader context."]
        })]
      }), _jsxs(AccordionItem, {
        title: "Do you have a referral program?",
        children: [_jsx(_components.p, {
          children: _jsx(_components.em, {
            children: "Referrals, dev-fee split, & white-labeling."
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Braiins Pool"
          })
        }), _jsx(_components.p, {
          children: "Unfortunately, we don’t run a referral program at the moment. Since Braiins Pool accounts are free and pseudonymous, it would be hard to prevent abuse of such a program."
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Braiins OS"
          })
        }), _jsxs(_components.p, {
          children: ["The ", _jsx(_components.a, {
            href: "https://braiins.com/os/plus/partnership?utm_source=help",
            children: "Braiins Partnership Program"
          }), " (BPP) offers a mutually beneficial relationship between Braiins and BPP participants. While we have an extensive network within the Bitcoin mining industry, we realize there are still many opportunities outside of our current sphere."]
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Referral"
          })
        }), _jsxs(_components.p, {
          children: ["Partners offer us value through their own extended networks and can directly contribute to the growth of Braiins and our product suite. In return, ", _jsx(_components.strong, {
            children: "Braiins offers financial incentives in the form of hashrate (i.e. dev-fee split)"
          }), " which rewards participants in a steady income of Bitcoin, the amount of which is directly related to the volume of hashrate received from the participant."]
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "White-label"
          })
        }), _jsx(_components.p, {
          children: "Braiins Partners can also white-label our firmware, Braiins OS, and offer it to their network. Enjoy the benefits of running your own branded tuning firmware without the extensive development resources required to build it. Our expertise becomes your own."
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Pool benefits"
          })
        }), _jsxs(_components.p, {
          children: ["BPP participants also receive incentives in the form of ", _jsx(_components.strong, {
            children: "reduced mining pool fees"
          }), " if they mine with Braiins Pool."]
        })]
      }), _jsxs(AccordionItem, {
        title: "Is Braiins Pool compatible with NiceHash?",
        children: [_jsx(_components.p, {
          children: "NiceHash is a platform where you can buy hash rate which you can then use on our pool to mine - see “What is cloud mining” below this article."
        }), _jsx(_components.p, {
          children: "Yes, Braiins Pool is compatible with NiceHash services, meaning you can send hash rate bought on Nice hash to Braiins Pool. However, we cannot guarantee non-stop compatibility as NiceHash is operated by another 3rd party."
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://help.braiins.com/en/support/tickets/new",
            children: "Contact us"
          }), " if you need assistance."]
        })]
      }), _jsxs(AccordionItem, {
        title: "What is cloud mining?",
        children: [_jsx(_components.p, {
          children: "There are companies which own mining hardware located in their own facility and provide its hash rate to users for a certain fee. As a user of this service, you don’t need to own the mining hardware (e.g. SHA-256 ASICs for Bitcoin), but you pay for a specific amount of hash rate for a specific time period. It’s typically called a mining contract."
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Note: Braiins Pool does not offer cloud mining services or investment opportunities! If you are approached by anybody claiming to represent Braiins Pool and offering cloud mining, it is a scam!"
          })
        }), _jsxs(_components.p, {
          children: ["Read our ", _jsx(_components.a, {
            href: "https://braiins.com/blog/bitcoin-mining-scams",
            children: "blog article"
          }), " on the topic ”", _jsx(_components.strong, {
            children: "Bitcoin Mining Scams to Avoid (Braiins Pool Impersonators)"
          }), "”"]
        }), _jsx(_components.p, {
          children: "We strongly recommend that you properly calculate the financial efficiency before buying any cloud mining contracts. The cloud mining companies usually charge an additional maintenance fee and, in a lot of cases, the returns may be lower than the costs."
        })]
      }), _jsxs(AccordionItem, {
        title: "A Braiins Pool agent has offered me an investment opportunity. Is it a scam?",
        children: [_jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "We do not require any payments or investments from our users!"
          }), " We are a mining pool service, meaning you need to operate your own hardware and send that computing power to us in order to stabilize your mining rewards. You have to understand how mining and pools work."]
        }), _jsxs(_components.p, {
          children: ["Read our ", _jsx(_components.a, {
            href: "https://braiins.com/blog/bitcoin-mining-scams?utm_source=help",
            children: "blog article"
          }), " on the topic ”", _jsx(_components.strong, {
            children: "Bitcoin Mining Scams to Avoid (Braiins Pool Impersonators)"
          }), "“."]
        }), _jsx(_components.p, {
          children: "If you have been offered any investment opportunity from anybody claiming to be affiliated with us it is a scam! There are no official Braiins Pool consultants who would offer “investments opportunities” on the internet. It is a common tactic from many scammers nowadays and, unfortunately, there isn’t much we can do to prevent it."
        }), _jsx(_components.p, {
          children: "Please be aware of suspicious email addresses created on regular services like Gmail. Our employees (including support agents) only communicate using addresses from the domain: braiins.com."
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://help.braiins.com/en/support/tickets/new",
            children: "Contact us"
          }), " ", _jsx(_components.strong, {
            children: "if you need assistance. We are here to help"
          }), "."]
        })]
      })]
    }), "\n", _jsx(Feedback, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
